import { FeaturesService } from '@/services';
import { derived, writable } from 'svelte/store';
const initialState = [];
const store = writable(initialState);
const actions = {
    init: async () => {
        const features = await new FeaturesService().getAll();
        store.set(features);
    },
    isEnabled: (id) => {
        return derived(store, $store => $store.find(feature => feature.id === id)?.enabled ?? false);
    },
    get: (id) => {
        return derived(store, $store => $store.find(feature => feature.id === id));
    },
    update: async (id, enabled) => {
        await new FeaturesService().patch(id, { enabled });
        actions.init();
    }
};
export const featuresStore = {
    subscribe: store.subscribe,
    ...actions
};
export default featuresStore;
